import React, { useState, useEffect, useContext } from "react";
import Header from "../../generalPages/directives/header";
import Footer from "../commanComponents/userfooter";
import { Container, Row, Col, Button, Card, Dropdown, Modal, Form } from "react-bootstrap";
import "../commanComponents/componentCSS/propertydetail.css";
import { toast, Toaster } from "react-hot-toast";
import { useParams, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { AiOutlineHeart, AiFillHeart, AiFillStar, AiFillFacebook, AiFillLinkedin } from "react-icons/ai";
import { RxCopy } from "react-icons/rx";
import { BsShare, BsWhatsapp, BsStopwatch } from "react-icons/bs";
import "../commanComponents/componentCSS/listingproperty.css";
import { useNavigate } from "react-router-dom";
import Maps from "../Maps";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { LuBadgeCheck } from "react-icons/lu";
import { LinkedinShareButton, FacebookShareButton, WhatsappShareButton } from "react-share";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../commanComponents/componentCSS/swiper.css";
import { Pagination, Navigation } from "swiper/modules";
import { CurrencyContext } from "../../currencyConvertor/CurrencyContext";
import { getHotelContent, getRoomsAndRates } from "../../generalPages/zentrumhub/ZenApi";
import CryptoJS from 'crypto-js';
import slugify from "slugify";
import { add, set } from "lodash";

const ZenPropertyDetail = () => {
    const { hotelName, hotelId, checkin, checkout } = useParams();
    const { currency, convertPrice } = useContext(CurrencyContext);
    const [showShareModal, setShowShareModal] = useState(false);
    const [isImagesModalOpen, setIsImagesModalOpen] = useState(false);
    const [isRoomImagesModalOpen, setIsRoomImagesModalOpen] = useState(false);
    const [roomTypeImages, setRoomTypeImages] = useState([]);
    const [roomName, setRoomName] = useState('');
    const [selectedRoomType, setSelectedRoomType] = useState(null);
    const [propertyData, setPropertyData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showNoRoomsModal, setShowNoRoomsModal] = useState(false);
    const [reccommendedRoomId, setReccommendedRoomId] = useState(null);
    const [roomAndRateData, setRoomAndRateData] = useState(null);
    const navigate = useNavigate();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    const [guestsCount, setguestCount] = useState({
        adults: 1,
        children: 0,
        infants: 0,
        pets: 0,
    });

    const [dates, setDates] = useState([
        new DateObject().add(1, "day"),
        new DateObject().add(1, "day"),
    ]);

    useEffect(() => {
        if (checkin && checkout) {
            setDates([
                new DateObject(checkin),
                new DateObject(checkout)
            ]);
        }
    }, [checkin, checkout]);

    const [showAllAmenities, setShowAllAmenities] = useState(false);

    // const transformApiData = (apiData, roomsRatesData) => {
    //     // Default fallback values
    //     const defaultHotel = {
    //         name: "Hotel",
    //         contact: { address: { city: { name: 'Unknown City' }, country: { name: 'Unknown Country' } } },
    //         descriptions: [{ text: "No description available" }],
    //         category: "Hotel",
    //         facilities: [],
    //         policies: [],
    //         images: [{ links: [{ url: "/images/no_image_found2.jpg" }] }]
    //     };

    //     const hotel = apiData?.hotels?.[0] || defaultHotel;
    //     setRoomAndRateData(roomsRatesData);

    //     // Create rates mapping
    //     const ratesMapping = {};
    //     roomsRatesData?.hotel?.rates?.forEach(rate => {
    //         const roomId = rate.occupancies?.[0]?.roomId;
    //         if (roomId) {
    //             if (!ratesMapping[roomId]) {
    //                 ratesMapping[roomId] = [];
    //             }
    //             ratesMapping[roomId].push(rate);
    //         }
    //     });

    //     // Create standardized rooms mapping by stdRoomId for easy lookup
    //     const standardizedRoomsMap = {};
    //     roomsRatesData?.hotel?.standardizedRooms?.forEach(room => {
    //         standardizedRoomsMap[room.id] = room;
    //     });

    //     // Transform room types
    //     const roomTypes = roomsRatesData?.hotel?.rooms?.map((room, index) => {
    //         const roomRates = ratesMapping[room.id] || [];
    //         const firstRate = roomRates[0] || {};

    //         // Find matching standardized room by stdRoomId from the rate
    //         const stdRoomId = firstRate.occupancies?.[0]?.stdRoomId;
    //         const standardizedRoom = stdRoomId ? standardizedRoomsMap[stdRoomId] : null;

    //         return {
    //             id: index + 1,
    //             roomId: room.id,
    //             roomName: room.name || `Room ${index + 1}`,
    //             personsAllowed: firstRate?.occupancies?.[0]?.numOfAdults || 1,
    //             basePrice: firstRate.baseRate || 0,
    //             price: firstRate.totalRate || 0,
    //             taxAmt: firstRate.taxes?.[0]?.amount || 0,
    //             rates: roomRates,
    //             images: standardizedRoom?.images?.length > 0
    //                 ? standardizedRoom.images.map(img => ({
    //                     fileNameImage: img.links.find(link => link.size === "Standard")?.url ||
    //                         img.links[0]?.url ||
    //                         "/images/no_image_found2.jpg"
    //                 }))
    //                 : [{ fileNameImage: "/images/no_image_found2.jpg" }],
    //             cancellationPolicy: firstRate.cancellationPolicies?.[0]?.rules?.[0]?.value || 0,
    //             refundable: firstRate.refundable || false,
    //             boardBasis: firstRate.boardBasis?.description || "Room Only"
    //         };
    //     }) || [];

    //     // Get primary image
    //     const getPrimaryImage = (images) => {
    //         if (!images || images.length === 0) return "/images/no_image_found2.jpg";
    //         const primary = images.find(img => img.type === "Primary") || images[0];
    //         return primary.links?.find(link => link.size === "Xxl")?.url ||
    //             primary.links?.[0]?.url ||
    //             "/images/no_image_found2.jpg";
    //     };

    //     return {
    //         propertyName: hotel.name || "Hotel",
    //         location: `${hotel.contact?.address?.city?.name || 'Unknown City'}, ${hotel.contact?.address?.country?.name || 'Unknown Country'}`,
    //         description: hotel.descriptions?.find(d => d.type === "At the hotel")?.text ||
    //             hotel.descriptions?.[0]?.text ||
    //             "No description available",
    //         categoryName: hotel.category || "Hotel",
    //         numberOfBedrooms: 1,
    //         numberOfBathroom: 1,
    //         guestCount: 2,
    //         carParking: 0,
    //         bikeParking: 0,
    //         checkIn: hotel.checkinInfo?.beginTime?.substring(0, 5) || "14:00",
    //         checkOut: hotel.checkoutInfo?.time?.substring(0, 5) || "12:00",
    //         petsAllowed: hotel.facilities?.some(f => f.name.toLowerCase().includes('pet')) || false,
    //         price: roomTypes.length > 0 ? roomTypes[0].price : 0,
    //         cleaningAndMaintenanceFee: 0,
    //         taxPercentage: roomTypes.length > 0 ? roomTypes[0].taxAmt : 0,
    //         petsPrice: 0,
    //         latitude: parseFloat(hotel.geoCode?.lat) || 0,
    //         longitude: parseFloat(hotel.geoCode?.long) || 0,
    //         rating: parseFloat(hotel.starRating) || 0,
    //         terms: hotel.policies?.find(p => p.type === "Extra info")?.text ||
    //             hotel.policies?.[0]?.text ||
    //             "No terms available",
    //         cancellationPolicies: hotel.policies?.map((policy, index) => ({
    //             id: index + 1,
    //             policy: policy.text || policy.type
    //         })) || [],
    //         images: hotel.images ? hotel.images.map(img => ({
    //             fileNameImage: img.links.find(link => link.size === "Xxl")?.url || img.links[0]?.url
    //         })) : [{ fileNameImage: "/images/no_image_found2.jpg" }],
    //         amenities: hotel.facilities?.map((facility, index) => ({
    //             id: index + 1,
    //             name: facility.name,
    //             icon: facility.name.toLowerCase().includes('wifi') ? 'wifi' :
    //                 facility.name.toLowerCase().includes('parking') ? 'Parking' :
    //                     facility.name.toLowerCase().includes('pool') ? 'Pool' :
    //                         facility.name.toLowerCase().includes('air conditioning') ? 'ac' :
    //                             facility.name.toLowerCase().includes('restaurant') ? 'Kitchen' : 'Washer'
    //         })) || [],
    //         roomTypes: roomTypes,
    //         reviews: [],
    //         host: {
    //             firstName: "Hotel Staff",
    //             profile: hotel.heroImage || "/images/no_image_found2.jpg"
    //         }
    //     };
    // };


    const transformApiData = (apiData, roomsRatesData) => {
        // Default fallback values
        const defaultHotel = {
            name: "Hotel",
            contact: { address: { city: { name: 'Unknown City' }, country: { name: 'Unknown Country' } } },
            descriptions: [{ text: "No description available" }],
            category: "Hotel",
            facilities: [],
            policies: [],
            images: [{ links: [{ url: "/images/no_image_found2.jpg" }] }]
        };

        const hotel = apiData?.hotels?.[0] || defaultHotel;
        setRoomAndRateData(roomsRatesData);

        // Create rates mapping
        const ratesMapping = {};
        roomsRatesData?.hotel?.rates?.forEach(rate => {
            const roomId = rate.occupancies?.[0]?.roomId;
            if (roomId) {
                if (!ratesMapping[roomId]) {
                    ratesMapping[roomId] = [];
                }
                ratesMapping[roomId].push(rate);
            }
        });

        // Create standardized rooms mapping by stdRoomId for easy lookup
        const standardizedRoomsMap = {};
        roomsRatesData?.hotel?.standardizedRooms?.forEach(room => {
            standardizedRoomsMap[room.id] = room;
        });

        // Helper function to extract image URLs from different response formats
        const getImageUrls = (images) => {
            if (!images || !Array.isArray(images)) return ["/images/no_image_found2.jpg"];

            return images.map(img => {
                // Case 1: Direct URL property
                if (img.url) return img.url;

                // Case 2: Links array with URL property
                if (img.links?.[0]?.url) return img.links[0].url;

                // Case 3: Nested links with URL
                const firstLink = img.links?.[0];
                if (firstLink?.url) return firstLink.url;

                return "/images/no_image_found2.jpg";
            });
        };

        // Transform room types
        const roomTypes = roomsRatesData?.hotel?.rooms?.map((room, index) => {
            const roomRates = ratesMapping[room.id] || [];
            const firstRate = roomRates[0] || {};

            // Find matching standardized room by stdRoomId from the rate
            const stdRoomId = firstRate.occupancies?.[0]?.stdRoomId;
            const standardizedRoom = stdRoomId ? standardizedRoomsMap[stdRoomId] : null;

            // Get room images from standardized room or fallback
            const roomImageUrls = standardizedRoom?.images
                ? getImageUrls(standardizedRoom.images)
                : ["/images/no_image_found2.jpg"];

            return {
                id: index + 1,
                roomId: room.id,
                roomName: room.name || `Room ${index + 1}`,
                personsAllowed: firstRate?.occupancies?.[0]?.numOfAdults || 1,
                basePrice: firstRate.baseRate || 0,
                price: firstRate.totalRate || 0,
                taxAmt: firstRate.taxes?.[0]?.amount || 0,
                rates: roomRates,
                images: roomImageUrls.map(url => ({ fileNameImage: url })),
                cancellationPolicy: firstRate.cancellationPolicies?.[0]?.rules?.[0]?.value || 0,
                refundable: firstRate.refundable || false,
                boardBasis: firstRate.boardBasis?.description || "Room Only"
            };
        }) || [];

        // Get hotel images
        const hotelImageUrls = getImageUrls(hotel.images);
        const hotelImages = hotelImageUrls.map(url => ({ fileNameImage: url }));

        return {
            propertyName: hotel.name || "Hotel",
            location: `${hotel.contact?.address?.city?.name || 'Unknown City'}, ${hotel.contact?.address?.country?.name || 'Unknown Country'}`,
            description: hotel.descriptions?.find?.(d => d.type === "At the hotel")?.text ||
                hotel.descriptions?.[0]?.text ||
                "No description available",
            categoryName: hotel.category || "Hotel",
            numberOfBedrooms: 1,
            numberOfBathroom: 1,
            guestCount: 2,
            carParking: 0,
            bikeParking: 0,
            checkIn: hotel.checkinInfo?.beginTime?.substring(0, 5) || "14:00",
            checkOut: hotel.checkoutInfo?.time?.substring(0, 5) || "12:00",
            petsAllowed: hotel.facilities?.some?.(f => f.name.toLowerCase().includes('pet')) || false,
            price: roomTypes.length > 0 ? roomTypes[0].price : 0,
            cleaningAndMaintenanceFee: 0,
            taxPercentage: roomTypes.length > 0 ? roomTypes[0].taxAmt : 0,
            petsPrice: 0,
            latitude: parseFloat(hotel.geoCode?.lat) || 0,
            longitude: parseFloat(hotel.geoCode?.long) || 0,
            rating: parseFloat(hotel.starRating) || 0,
            terms: hotel.policies?.find?.(p => p.type === "Extra info")?.text ||
                hotel.policies?.[0]?.text ||
                "No terms available",
            cancellationPolicies: hotel.policies?.map?.((policy, index) => ({
                id: index + 1,
                policy: policy.text || policy.type
            })) || [],
            images: hotelImages,
            amenities: hotel.facilities?.map?.((facility, index) => ({
                id: index + 1,
                name: facility.name,
                icon: facility.name.toLowerCase().includes('wifi') ? 'wifi' :
                    facility.name.toLowerCase().includes('parking') ? 'Parking' :
                        facility.name.toLowerCase().includes('pool') ? 'Pool' :
                            facility.name.toLowerCase().includes('air conditioning') ? 'ac' :
                                facility.name.toLowerCase().includes('restaurant') ? 'Kitchen' : 'Washer'
            })) || [],
            roomTypes: roomTypes,
            reviews: [],
            host: {
                firstName: "Hotel Staff",
                profile: hotel.heroImage || "/images/no_image_found2.jpg"
            }
        };
    };


    useEffect(() => {
        const fetchHotelData = async () => {
            try {
                setLoading(true);
                const [hotelContent, roomsAndRates] = await Promise.all([
                    getHotelContent([hotelId]),
                    getRoomsAndRates(hotelId, token)
                ]);

                const transformedData = transformApiData(hotelContent, roomsAndRates);

                if (!transformedData?.roomTypes || transformedData.roomTypes.length === 0) {
                    setShowNoRoomsModal(true);
                } else {
                    setPropertyData(transformedData);
                    setSelectedRoomType(transformedData.roomTypes[0]);
                }
            } catch (err) {
                console.error('Error fetching hotel data:', err);
                setShowNoRoomsModal(false);
            } finally {
                setLoading(false);
            }
        };

        if (hotelId && token) {
            fetchHotelData();
        }
    }, [hotelId, token]);


    if (!propertyData) {
        return (
            <Modal show={showNoRoomsModal} onHide={() => setShowNoRoomsModal(false)} centered size="md" className="no-rooms-modal">
                <Modal.Header className="border-0">
                    <Modal.Title className="w-100 text-center text-danger fs-4 fw-bold">
                        Property Not Available
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center py-4">
                    <p className="fs-5 text-muted">The property details could not be loaded.</p>
                </Modal.Body>
                <Modal.Footer className="justify-content-center border-0 pb-4">
                    <Button variant="outline-danger" className="px-4 py-2 rounded-5 fw-semibold" onClick={() => window.history.back()}>
                        Go Back
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    if (loading) {
        return (
            <div className="loader-container">
                <img
                    src="assets/images/loader-home.gif"
                    style={{ height: "100px", width: "100px" }}
                    alt="Loading..."
                />
            </div>
        );
    }

    const selectedLocation = {
        lat: propertyData.latitude,
        lng: propertyData.longitude,
        location: propertyData.location,
    };

    const amenitiesToShow = showAllAmenities
        ? propertyData.amenities
        : propertyData.amenities.slice(0, 15);

    const createMarkup = (html) => {
        return { __html: html };
    };

    const copyText = () => {
        navigator.clipboard.writeText(window.location.href);
        toast.success("Copied to clipboard!");
    };

    console.log("Selected propertyData", propertyData);


    const selectRoomType = (room) => {
        setSelectedRoomType(room.id === selectedRoomType?.id ? null : room);
        //setReccommendedRoomId(room.rates.id ===);
    };

    const bookHandler = () => {
        if (!selectedRoomType) {
            toast.error('Please select a room type.');
            return;
        }


        const rateId = selectedRoomType.rates[0]?.id;

        const matchedRecommendation = roomAndRateData?.hotel?.recommendations?.find(
            (recomm) => recomm.rates.includes(rateId)
        );
        const recommendationId = matchedRecommendation?.id || null;


        const navData = {
            hotelName: propertyData ? propertyData.propertyName : '',
            address: propertyData ? propertyData.location : '',
            hotelId: hotelId,
            checkin: dates[0] ? dates[0].format("YYYY-MM-DD") : '',
            checkout: dates[1] ? dates[1].format("YYYY-MM-DD") : '',
            guestsCount: guestsCount,
            token: token,
            selectedRoom: selectedRoomType ? selectedRoomType : null,
            reccommendedRoomId: recommendationId,
            roomCount: selectedRoomType ? selectedRoomType.rates[0].occupancies.length : 0,
        };

        // Encryption settings
        const SECRET_KEY = process.env.REACT_APP_ENCRYPTION_KEY || 'your-secret-key-12345';

        // Encrypt the data
        const encryptData = (data) => {
            const jsonString = JSON.stringify(data);
            return CryptoJS.AES.encrypt(jsonString, SECRET_KEY).toString();
        };

        const encryptedData = encryptData(navData);
        const encodedData = encodeURIComponent(encryptedData);

        // Generate the URL with proper structure
        const hotelSlug = slugify(propertyData.propertyName, { lower: true, strict: true });


        // Navigate to the payment page
        navigate(`/zenpayment/${hotelSlug}?data=${encodedData}`);
    };

    return (
        <>
            <Header />
            <Toaster />
            <div>
                <section className="propertydetail pt-0 pb-0 overflow-hidden">
                    <Container className="mt-5">
                        <Row className="align-items-center">
                            <Col lg={6}>
                                <h3><b>{propertyData.propertyName}</b></h3>
                                <p className="mb-0">{propertyData.location}</p>
                            </Col>

                            <Col lg={6} className="text-right">
                                <div className="socialicon">
                                    {propertyData.rating > 0 && (
                                        <span className="me-3">
                                            <AiFillStar fill="#E46422" width="20px" /> &nbsp;
                                            {parseFloat(propertyData.rating).toFixed(1)}
                                        </span>
                                    )}

                                    <Button variant="transparent" className="border-0" onClick={() => setShowShareModal(true)}>
                                        <BsShare />
                                    </Button>
                                </div>
                                <div>{propertyData.categoryName}</div>
                            </Col>
                        </Row>
                    </Container>

                    {/* Property Images */}
                    <Container className="mt-3">
                        <Row>
                            <Col lg={6} className="px-1 mb-2">
                                <div className="propertydetailImg">
                                    <img
                                        src={propertyData.images[0]?.fileNameImage || "/images/no_image_found2.jpg"}
                                        alt="Property"
                                        className="img-fluid"
                                    />
                                </div>
                            </Col>
                            <Col lg={6} className="text-right px-1 mb-4">
                                <div className="collapsImg">
                                    <div className="nft_pic nft_multi">
                                        {propertyData.images.slice(1, 5).map((img, index) => (
                                            <a key={index} className="d-block">
                                                <img
                                                    src={img.fileNameImage}
                                                    alt={`Property ${index + 2}`}
                                                    className="img-fluid"
                                                />
                                                {index === 3 && propertyData.images.length > 5 && (
                                                    <Button
                                                        variant="default"
                                                        className="viewmore position-absolute rounded-2 btn-sm h-auto text-white border"
                                                        onClick={() => setIsImagesModalOpen(true)}
                                                    >
                                                        View More
                                                    </Button>
                                                )}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>

                    {/* Property Details */}
                    <div className="mb-4">
                        <Container>
                            <Row>
                                <Col lg={8}>
                                    {/* Basic Info */}
                                    <div className="amenities_list mb-5">
                                        <Row>
                                            <Col lg={6} md={6} xs={6} className="amenitiesBox">
                                                <div className="text-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="43" height="32" viewBox="0 0 43 32" fill="none">
                                                        <path d="M5.87207 4.81061C5.87207 4.06519 6.1781 3.3503 6.72283 2.82321C7.26756 2.29612 8.00637 2 8.77674 2H33.9505C34.7209 2 35.4597 2.29612 36.0044 2.82321C36.5491 3.3503 36.8552 4.06519 36.8552 4.81061V15.1162H5.87207V4.81061Z" stroke="#E46422" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M3.93652 26.3586V30.1061" stroke="#E46422" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M38.792 26.3586V30.1061" stroke="#E46422" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M26.206 10.4316H16.5238C15.7534 10.4316 15.0146 10.7278 14.4699 11.2549C13.9252 11.7819 13.6191 12.4968 13.6191 13.2423V15.116H29.1107V13.2423C29.1107 12.4968 28.8047 11.7819 28.2599 11.2549C27.7152 10.7278 26.9764 10.4316 26.206 10.4316Z" stroke="#E46422" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M2 17.9268C2 17.1814 2.30603 16.4665 2.85076 15.9394C3.39549 15.4123 4.1343 15.1162 4.90466 15.1162H37.8242C38.5946 15.1162 39.3334 15.4123 39.8781 15.9394C40.4228 16.4665 40.7289 17.1814 40.7289 17.9268V26.3587H2V17.9268Z" stroke="#E46422" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                    <p className="mt-2">
                                                        {selectedRoomType?.personsAllowed} Guests / Total Occupancy
                                                    </p>
                                                </div>
                                            </Col>

                                            <Col lg={6} md={6} xs={6}>
                                                <div className="text-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
                                                        <circle cx="19" cy="19" r="17" stroke="#E46422" strokeWidth="3" />
                                                        <path d="M19 12.2V18.7324C19 18.8995 19.0836 19.0557 19.2226 19.1484L24.1 22.4" stroke="#E46422" strokeWidth="3" strokeLinecap="round" />
                                                    </svg>
                                                    <p className="mt-2">
                                                        {propertyData.checkIn} {parseInt(propertyData.checkIn) < 12 ? "AM" : "PM"} to {propertyData.checkOut} {parseInt(propertyData.checkOut) < 12 ? "AM" : "PM"}
                                                    </p>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Description */}
                                    <Col lg={12} className="mb-5">
                                        <h5 className="mb-3"><b>Property Description</b></h5>
                                        <div dangerouslySetInnerHTML={createMarkup(propertyData.description)} />
                                    </Col>

                                    {/* Policies */}
                                    {propertyData.cancellationPolicies.length > 0 && (
                                        <Col lg={12} className="mb-5">
                                            <h5 className="mb-3"><b>Property Policies</b></h5>
                                            <Row>
                                                {propertyData.cancellationPolicies.map(policy => (
                                                    <Col lg={12} className="mb-2" key={policy.id}>
                                                        <div dangerouslySetInnerHTML={{ __html: policy.policy }} />
                                                    </Col>
                                                ))}
                                            </Row>
                                        </Col>
                                    )}

                                    {/* Amenities */}
                                    {propertyData.amenities.length > 0 && (
                                        <Col lg={12} className="mb-5">
                                            <h5 className="mb-3"><b>Offered Amenities</b></h5>
                                            <Row>
                                                {amenitiesToShow.map((data) => (
                                                    <Col lg={4} key={data.id}>
                                                        <p><LuBadgeCheck className="me-2" />{data.name}</p>
                                                    </Col>
                                                ))}

                                                {propertyData.amenities.length > 15 && (
                                                    <Col lg={12} className="mt-2">
                                                        <Button
                                                            variant="link"
                                                            onClick={() => setShowAllAmenities(!showAllAmenities)}
                                                            className="p-0 text-primary"
                                                        >
                                                            {showAllAmenities ? "Show Less" : "Show More"}
                                                        </Button>
                                                    </Col>
                                                )}
                                            </Row>
                                        </Col>
                                    )}
                                </Col>

                                {/* Booking Card */}
                                <Col lg={4} className="mb-4">
                                    <Card className="rounded-4">
                                        <div className="px-4 pb-4 two_month_date mt-3">
                                            <Row className="align-items-center">
                                                <Col lg={12}>
                                                    <Button variant="" className="w-100 mb-4 text-black border-dark rounded-5 position-relative">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 22" fill="none">
                                                            <path d="M14.5 7.16H5.5C5.08579 7.16 4.75 7.49579 4.75 7.91C4.75 8.32421 5.08579 8.66 5.5 8.66H14.5C14.9142 8.66 15.25 8.32421 15.25 7.91C15.25 7.49579 14.9142 7.16 14.5 7.16Z" fill="black" />
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M14.89 2.57H15C17.7614 2.57 20 4.80858 20 7.57V16.57C20 19.3314 17.7614 21.57 15 21.57H5C3.67392 21.57 2.40215 21.0432 1.46447 20.1055C0.526784 19.1679 0 17.8961 0 16.57V7.57C0 4.80858 2.23858 2.57 5 2.57H5.09V0.75C5.09 0.335786 5.42579 0 5.84 0C6.25421 0 6.59 0.335786 6.59 0.75V2.57H13.39V0.75C13.39 0.335786 13.7258 0 14.14 0C14.5542 0 14.89 0.335786 14.89 0.75V2.57ZM15 20.07C16.933 20.07 18.5 18.503 18.5 16.57V7.57C18.5 5.637 16.933 4.07 15 4.07H5C3.067 4.07 1.5 5.637 1.5 7.57V16.57C1.5 18.503 3.067 20.07 5 20.07H15Z" fill="black" />
                                                        </svg>
                                                        &nbsp;
                                                        {dates[0].format("D MMM YY")} - {dates[1].format("D MMM YY")}
                                                    </Button>


                                                    <Button variant="default" id="dropdown-basic" className="w-100 text-black border-dark rounded-5">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M19.58 16.71L19.82 17.85C20.0474 18.8356 19.8228 19.8713 19.2076 20.6742C18.5924 21.4771 17.6508 21.9633 16.64 22H7.35997C6.34915 21.9633 5.40754 21.4771 4.79232 20.6742C4.1771 19.8713 3.95254 18.8356 4.17997 17.85L4.41997 16.71C4.69601 15.1668 6.02259 14.0327 7.58997 14H16.41C17.9774 14.0327 19.3039 15.1668 19.58 16.71ZM16.64 20.49C17.1478 20.4841 17.6256 20.2489 17.94 19.85V19.86C18.3257 19.3762 18.4759 18.7458 18.35 18.14L18.11 17C17.9768 16.1552 17.2646 15.5226 16.41 15.49H7.58998C6.73534 15.5226 6.02314 16.1552 5.88998 17L5.64998 18.14C5.52713 18.7426 5.67724 19.3687 6.05998 19.85C6.37431 20.2489 6.85219 20.4841 7.35998 20.49H16.64Z" fill="black" />
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M12.5 12H11.5C9.29082 12 7.49996 10.2092 7.49996 8.00001V5.36001C7.49729 4.46807 7.85043 3.61189 8.48113 2.98119C9.11184 2.35049 9.96802 1.99735 10.86 2.00001H13.14C14.0319 1.99735 14.8881 2.35049 15.5188 2.98119C16.1495 3.61189 16.5026 4.46807 16.5 5.36001V8.00001C16.5 10.2092 14.7091 12 12.5 12ZM10.86 3.50002C9.83271 3.50002 8.99996 4.33277 8.99996 5.36001V8.00001C8.99996 9.38073 10.1192 10.5 11.5 10.5H12.5C13.8807 10.5 15 9.38073 15 8.00001V5.36001C15 4.86671 14.804 4.39361 14.4552 4.0448C14.1064 3.69598 13.6333 3.50002 13.14 3.50002H10.86Z" fill="black" />
                                                        </svg>
                                                        &nbsp;
                                                        {selectedRoomType?.rates?.[0]?.occupancies ? (
                                                            (() => {
                                                                const occ = selectedRoomType.rates[0].occupancies;
                                                                const totalRooms = occ.length;
                                                                const totalAdults = occ.reduce((sum, o) => sum + parseInt(o.numOfAdults || 0), 0);
                                                                const totalChildren = occ.reduce((sum, o) => sum + parseInt(o.numOfChildren || 0), 0);
                                                                return `${totalAdults} Guests • ${totalRooms} Rooms • ${totalChildren} Child`;
                                                            })()
                                                        ) : (
                                                            ''
                                                        )}
                                                    </Button>


                                                </Col>
                                                <Col lg={12} className="mb-3">
                                                    <div className="mb-3">
                                                        <div className="d-flex justify-content-between text-grey border-bottom p-2">
                                                            <div>Base Price:</div>
                                                            <div>+ ${convertPrice(selectedRoomType?.basePrice || 0)} {currency}</div>
                                                        </div>
                                                        <div className="d-flex justify-content-between text-grey border-bottom p-2">
                                                            <div>Taxes & Other Charges:</div>
                                                            <div>+ ${convertPrice((selectedRoomType?.price - selectedRoomType?.basePrice) || 0)} {currency}</div>
                                                        </div>

                                                        <div className="d-flex justify-content-between p-2">
                                                            <div className="fw-bold">Total Price:</div>
                                                            <div className="fw-bold">
                                                                ${convertPrice(selectedRoomType?.price || 0)} {currency}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <Button
                                                        variant="primary"
                                                        className="w-100 rounded-5"
                                                        onClick={bookHandler}
                                                        disabled={!selectedRoomType}
                                                    >
                                                        Reserve Now
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Card>
                                </Col>
                            </Row>

                            {/* Room Types */}
                            {propertyData?.roomTypes?.length > 0 && (
                                <>
                                    <hr />
                                    <Col lg={12}>
                                        <h5 className="mb-3"><b>Room Types</b></h5>
                                        <Row>
                                            {propertyData.roomTypes.map(room => (
                                                <Col lg={4} className="my-3" key={room.id}>
                                                    <h6 className="mb-3" style={{ minHeight: '38px' }}><b>{room.roomName}</b></h6>
                                                    <Card className="border-0">
                                                        <div className="post-image-card position-relative">
                                                            <div className="rounded-2 bg-black overflow-hidden">
                                                                <img
                                                                    className="card-img-top opacity-75"
                                                                    src={room?.images?.[0]?.fileNameImage || "/images/no_image_found2.jpg"}
                                                                    style={{ width: "100%", height: "250px", objectFit: "cover" }}
                                                                    alt={room.roomName}
                                                                />
                                                            </div>
                                                            {room.images.length > 1 && (
                                                                <div className="image-h">
                                                                    <Button
                                                                        variant="default"
                                                                        className="viewmore position-absolute rounded-2 btn-sm h-auto text-white border"
                                                                        onClick={() => {
                                                                            setRoomTypeImages(room.images);
                                                                            setRoomName(room.roomName);
                                                                            setIsRoomImagesModalOpen(true);
                                                                        }}
                                                                    >
                                                                        View More
                                                                    </Button>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <Card.Body>
                                                            <div className="d-md-flex justify-content-between align-items-center">
                                                                <h5 className="mb-0">
                                                                    ${convertPrice(room.price)} {currency}
                                                                </h5>
                                                                <Button
                                                                    variant={selectedRoomType?.id === room.id ? "primary" : "light"}
                                                                    className="border rounded-5"
                                                                    onClick={() => selectRoomType(room)}
                                                                >
                                                                    {selectedRoomType?.id === room.id ? "Selected" : "Select Room"}
                                                                </Button>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            ))}
                                        </Row>
                                    </Col>
                                    <hr />
                                </>
                            )}
                        </Container>
                    </div>

                    {/* Map */}
                    <div style={{ width: "100%" }}>
                        <Maps selectedLocation={selectedLocation} />
                    </div>
                    <hr className="mt-0" />
                </section>

                {/* Property Images Modal */}
                <Modal
                    show={isImagesModalOpen}
                    onHide={() => setIsImagesModalOpen(false)}
                    size="lg"
                    centered
                    className="hotelImages"
                >
                    <Modal.Header closeButton>
                        <Modal.Title><b>{propertyData.propertyName}</b></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Swiper
                            pagination={{ type: "fraction" }}
                            navigation={true}
                            modules={[Pagination, Navigation]}
                            className="mySwiper"
                        >
                            {propertyData.images.map((img, index) => (
                                <SwiperSlide key={index}>
                                    <img src={img.fileNameImage} alt={`Property ${index + 1}`} className="img-fluid" />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </Modal.Body>
                </Modal>

                {/* Room Images Modal */}
                <Modal
                    show={isRoomImagesModalOpen}
                    onHide={() => setIsRoomImagesModalOpen(false)}
                    size="lg"
                    centered
                    className="hotelImages"
                >
                    <Modal.Header closeButton>
                        <Modal.Title><b>{roomName} Room</b></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Swiper
                            pagination={{ type: "fraction" }}
                            navigation={true}
                            modules={[Pagination, Navigation]}
                            className="mySwiper"
                        >
                            {roomTypeImages.map((img, index) => (
                                <SwiperSlide key={index}>
                                    <img src={img.fileNameImage} alt={`Room ${index + 1}`} className="img-fluid" />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </Modal.Body>
                </Modal>

                {/* Share Modal */}
                <Modal show={showShareModal} onHide={() => setShowShareModal(false)} size="md">
                    <Modal.Header closeButton>
                        <Modal.Title><b>Share this place</b></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="d-flex align-items-center">
                            <div className="me-2">
                                <img
                                    src={propertyData.images[0]?.fileNameImage || "/images/no_image_found2.jpg"}
                                    alt=""
                                    height="62px"
                                    width="100px"
                                    className="object-fit-contain rounded-2"
                                />
                            </div>
                            <div>
                                <p className="mb-0">
                                    {propertyData.propertyName} in {propertyData.location} ·
                                    {propertyData.numberOfBedrooms} bedroom ·
                                    {propertyData.numberOfBathroom} private bathroom
                                </p>
                            </div>
                        </div>
                        <br />
                        <Row>
                            <Col lg={6} className="mb-3">
                                <Button variant="transparent" className="rounded-3 w-100 border-1 border-secondary" onClick={copyText}>
                                    <RxCopy size={23} fill="#E46422" /> &nbsp; Copy Link
                                </Button>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <LinkedinShareButton url={window.location.href} className="w-100">
                                    <Button variant="transparent" className="rounded-3 w-100 border-1 border-secondary">
                                        <AiFillLinkedin fill="#0072b1" size={23} /> &nbsp; Linkedin
                                    </Button>
                                </LinkedinShareButton>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <WhatsappShareButton url={window.location.href} className="w-100">
                                    <Button variant="transparent" className="rounded-3 w-100 border-1 border-secondary">
                                        <BsWhatsapp fill="#25d366" size={23} /> &nbsp; Whatsapp
                                    </Button>
                                </WhatsappShareButton>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <FacebookShareButton url={window.location.href} className="w-100">
                                    <Button variant="transparent" className="rounded-3 w-100 border-1 border-secondary">
                                        <AiFillFacebook fill="#1877F2" size={23} /> Facebook
                                    </Button>
                                </FacebookShareButton>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>

                {/* No Rooms Modal */}
                <Modal show={showNoRoomsModal} onHide={() => setShowNoRoomsModal(false)} centered size="md" className="no-rooms-modal">
                    <Modal.Header className="border-0">
                        <Modal.Title className="w-100 text-center text-danger fs-4 fw-bold">
                            No Rooms Available
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center py-4">
                        <p className="fs-5 text-muted">No room types are available for the selected property at the moment.</p>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center border-0 pb-4">
                        <Button variant="outline-danger" className="px-4 py-2 rounded-5 fw-semibold" onClick={() => window.history.back()}>
                            Go Back
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>

            <Footer />
        </>
    );
};

export default ZenPropertyDetail;